<template>
    <!-- 智慧运维内容 -->
    <div id="tab1" class="page-width main-content">
        <!-- 产品介绍 -->
        <div>
            <div class="sub-title">
                <p>智慧运维</p>
            </div>
            <div class="intro">
                智慧运维包含智慧运维综合管理平台、智慧运维App两部分，核心模块包括设备台账、设备维修维保、知识库等主要功能。通过专业的技术，借助智能化、信息化手段为客户提供一站式运维管理服务，保证设备的安全、可靠、长期稳定运转，实现资源最优配置。
            </div>
        </div>
        <!-- 运维流程 -->
        <div>
            <img
                src="../../../../../assets/img/softProduct/zhyw/repair_flow.png"
                alt="运维流程"
                class="app-img"
            />
        </div>
        <!-- 行业痛点 -->
        <div>
            <div class="sub-title">
                <p>行业痛点</p>
            </div>
            <div class="cateBox">
                <ul class="proCateUl">
                    <li class="proCateLi">
                        <div class="leftBox">
                            <img
                                src="../../../../../assets/img/softProduct/zhyw/数据.png"
                                class="fimg"
                                alt="数据"
                            />
                        </div>
                        <div class="rightBox">
                            <h3 class="proCateName">数据可靠性低</h3>
                            <article class="summary">
                                <p>
                                    原始数据记录不准确、不及时，导致数据可靠性得不到保证。
                                </p>
                            </article>
                        </div>
                    </li>
                    <li class="proCateLi">
                        <div class="leftBox">
                            <img
                                src="../../../../../assets/img/softProduct/zhyw/业务中心.png"
                                class="fimg"
                                alt="业务"
                            />
                        </div>
                        <div class="rightBox">
                            <h3 class="proCateName">业务流转效率低</h3>
                            <article class="summary">
                                <p>
                                    预防性维保计划制定及任务执行、应急性报修及派工单等，在开展的过程中靠纸质流转单的方式，效率低，不易存储。
                                </p>
                            </article>
                        </div>
                    </li>
                    <li class="proCateLi">
                        <div class="leftBox">
                            <img
                                src="../../../../../assets/img/softProduct/zhyw/监督.png"
                                class="fimg"
                                alt="监督"
                            />
                        </div>
                        <div class="rightBox">
                            <h3 class="proCateName">工作监督不到位</h3>
                            <article class="summary">
                                <p>
                                    对于一线人员在设备维保、维修的工作中的执行情况无法做到有效监督。
                                </p>
                            </article>
                        </div>
                    </li>
                    <li class="proCateLi">
                        <div class="leftBox">
                            <img
                                src="../../../../../assets/img/softProduct/zhyw/共享.png"
                                class="fimg"
                                alt="共享"
                            />
                        </div>
                        <div class="rightBox">
                            <h3 class="proCateName">信息共享不畅通</h3>
                            <article class="summary">
                                <p>
                                    设备台账、维修经验等信息都各自维护，缺乏有效共享手段。
                                </p>
                            </article>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <!-- 产品优势 -->
        <div class="soms-funciton">
            <div class="sub-title">
                <p>产品优势</p>
            </div>
            <div class="flex card-page flex-wrap">
                <div class="card-text">
                    <p class="p1">实时查询设备信息资料</p>
                    <p class="p2">
                        扫描设备二维码，查询设备基本信息、运行参数、设备图纸等相关文档资料，基于设备信息为维修人员提供操作指引，便于维修工作规范有效地执行。
                    </p>
                </div>
                <img
                    src="../../../../../assets/img/softProduct/zhyw/1.png"
                    alt=""
                    class="app-img"
                />
            </div>
            <div class="grey-bg flex card-page flex-wrap flex-end">
                <img
                    src="../../../../../assets/img/softProduct/zhyw/2.png"
                    alt=""
                    class="app-img"
                />
                <div class="card-text">
                    <p class="p1">实时掌控设备运行状况</p>
                    <p class="p2">
                        远程监控工厂设备实时数据，以工艺流程图的方式展示，数据一目了然。
                    </p>
                </div>
            </div>
            <div class="flex card-page flex-wrap">
                <div class="card-text">
                    <p class="p1">在线报修申请</p>
                    <p class="p2">
                        支持多种终端在线报修申请。系统自动派单或手工派单指定维修人。报修人可随时查看报修单处理进度。
                    </p>
                </div>
                <img
                    src="../../../../../assets/img/softProduct/zhyw/3.png"
                    alt=""
                    class="app-img"
                />
            </div>
            <div class="grey-bg flex card-page flex-wrap flex-end">
                <img
                    src="../../../../../assets/img/softProduct/zhyw/4.png"
                    alt=""
                    class="app-img"
                />
                <div class="card-text">
                    <p class="p1">维修过程动态跟踪</p>
                    <p class="p2">
                        跟踪记录维修执行全过程，维修结束后生成维修记录表，记录维修时间、维修人员、处理问题、解决方案等详细信息并上传存档，供后续维修和故障检修参考查阅。
                    </p>
                </div>
            </div>
            <div class="flex card-page flex-wrap">
                <div class="card-text">
                    <p class="p1">强大的预防性维护</p>
                    <p class="p2">
                        灵活实现设备维护保养的维保计划、维保标准的编制，自动生成维保任务。跟踪任务进度，调整后续计划。
                    </p>
                </div>
                <img
                    src="../../../../../assets/img/softProduct/zhyw/5.png"
                    alt=""
                    class="app-img"
                />
            </div>
            <div class="grey-bg flex card-page flex-wrap flex-end">
                <img
                    src="../../../../../assets/img/softProduct/zhyw/6.png"
                    alt=""
                    class="app-img"
                />
                <div class="card-text">
                    <p class="p1">多种统计分析方式</p>
                    <p class="p2">
                        建立智能化的综合查询及统计分析报表，使数据分析统计工作发挥其应有的作用，为企业领导和决策部门做好后勤保障工作。
                    </p>
                </div>
            </div>
        </div>
        <!-- 解决问题 -->
        <div>
            <div class="sub-title">
                <p>解决问题</p>
            </div>
            <div class="flex card-page flex-wrap">
                <div class="card-text">
                    <p class="p1">全部设备统一分类、全面共享</p>
                    <p class="p2">
                        设备按项目、系统分类管理，全面共享，支持多端管理。报修或制定维保计划直接选择清单中设备即可。
                    </p>
                </div>
                <img
                    src="../../../../../assets/img/softProduct/zhyw/7.png"
                    alt=""
                    class="app-img"
                />
            </div>
            <div class="grey-bg flex card-page flex-wrap flex-end">
                <img
                    src="../../../../../assets/img/softProduct/zhyw/8.png"
                    alt=""
                    class="app-img"
                />
                <div class="card-text">
                    <p class="p1">工作的有效监督</p>
                    <p class="p2">
                        全程记录维保执行过程、维修过程，实时跟踪维保任务进度、维修进度，做到了工作的有效监督。
                    </p>
                </div>
            </div>
            <div class="flex card-page flex-wrap">
                <div class="card-text">
                    <p class="p1">维修知识的积累和传承</p>
                    <p class="p2">
                        将相关维修知识以文字或文档的形式上传到知识库，为日常维修工作提供详细、有效的技术支持，提高维修人员的维修效率，避免因维修不当二次损伤设备。
                    </p>
                </div>
                <img
                    src="../../../../../assets/img/softProduct/zhyw/9.png"
                    alt=""
                    class="app-img fixed-img"
                />
            </div>
        </div>
        <!-- 平台展示 -->
        <div>
            <div class="sub-title">
                <p>智慧运维综合管理平台展示</p>
            </div>
            <div class="container-fluid show-plat">
                <div class="row no-gutters">
                    <div class="col-sm-4 col-xs-12">
                        <div class="portfolio-item wow fadeInUp">
                            <img
                                src="../../../../../assets/img/softProduct/zhyw/plat1.png"
                                alt="控制台"
                            />
                            <div class="portfolio-overlay">
                                <div class="portfolio-info">
                                    <h2 class="wow fadeInUp">控制台</h2>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4 col-xs-12">
                        <div class="portfolio-item wow fadeInUp">
                            <img
                                src="../../../../../assets/img/softProduct/zhyw/plat3.png"
                                alt="维保任务"
                            />
                            <div class="portfolio-overlay">
                                <div class="portfolio-info">
                                    <h2 class="wow fadeInUp">维保任务</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4 col-xs-12">
                        <div class="portfolio-item wow fadeInUp">
                            <img
                                src="../../../../../assets/img/softProduct/zhyw/soms_web_11.png"
                                alt="维保统计分析"
                            />
                            <div class="portfolio-overlay">
                                <div class="portfolio-info">
                                    <h2 class="wow fadeInUp">维保统计分析</h2>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4 col-xs-12">
                        <div class="portfolio-item wow fadeInUp">
                            <img
                                src="../../../../../assets/img/softProduct/zhyw/plat5.png"
                                alt="设备清单"
                            />
                            <div class="portfolio-overlay">
                                <div class="portfolio-info">
                                    <h2 class="wow fadeInUp">设备二维码</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4 col-xs-12">
                        <div class="portfolio-item wow fadeInUp">
                            <img
                                src="../../../../../assets/img/softProduct/zhyw/plat2.png"
                                alt="运行数据"
                            />
                            <div class="portfolio-overlay">
                                <div class="portfolio-info">
                                    <h2 class="wow fadeInUp">运行数据</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4 col-xs-12">
                        <div class="portfolio-item wow fadeInUp">
                            <img
                                src="../../../../../assets/img/softProduct/zhyw/soms_web_15.png"
                                alt="视频监控"
                            />
                            <div class="portfolio-overlay">
                                <div class="portfolio-info">
                                    <h2 class="wow fadeInUp">视频监控</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 智慧运维展示 -->
        <div>
            <div class="sub-title">
                <p>智慧运维App展示</p>
            </div>
            <div class="container-fluid show-app">
                <div class="row no-gutters">
                    <div class="col-sm-3 col-xs-3">
                        <div class="portfolio-item wow fadeInUp">
                            <img
                                src="../../../../../assets/img/softProduct/zhyw/app9.jpg"
                                alt="主页面"
                            />
                            <div class="portfolio-overlay">
                                <div class="portfolio-info">
                                    <h2 class="wow fadeInUp">主页面</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3 col-xs-3">
                        <div class="portfolio-item wow fadeInUp">
                            <img
                                src="../../../../../assets/img/softProduct/zhyw/app2.jpg"
                                alt="添加设备"
                            />
                            <div class="portfolio-overlay">
                                <div class="portfolio-info">
                                    <h2 class="wow fadeInUp">添加设备</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3 col-xs-3">
                        <div class="portfolio-item wow fadeInUp">
                            <img
                                src="../../../../../assets/img/softProduct/zhyw/app7.jpg"
                                alt="报修列表"
                            />
                            <div class="portfolio-overlay">
                                <div class="portfolio-info">
                                    <h2 class="wow fadeInUp">报修列表</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-3 col-xs-3">
                        <div class="portfolio-item wow fadeInUp">
                            <img
                                src="../../../../../assets/img/softProduct/zhyw/app6.jpg"
                                alt="我的"
                            />
                            <div class="portfolio-overlay">
                                <div class="portfolio-info">
                                    <h2 class="wow fadeInUp">我的</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="img-bottom"></div>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
@import './softProduct.less';
.soms-funciton {
    .flex {
        align-items: center;
    }
    .card-text {
        justify-content: center;
    }
}
</style>
